


































import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { SingleOptionSelectableMixin, StandardOption} from "./mixins";
import { BrowserUtility, BrowserKinds } from "../../../utilities";
import InfiniteLoading from "vue-infinite-loading";

@Component({
  components: {
    InfiniteLoading
  },
})
export default class OptionListBoxSelector extends Mixins(SingleOptionSelectableMixin) {
  // TODO Firefox対応時にホイールでスクロール量減少問題があったためselectタグを使用しない実装を検討する
  @Prop({ default: false })
  isClearable: boolean;

  @Prop({default: 50 })
  loadChunkSize: number;

  data(): any {
    return {
      chunkedCount: 0,
      loadOptions: [],
      loadedOptions: [],
      infiniteLoading: null,
      preSelected: null as StandardOption<any>,
      isClicked: false,
    };
  }
  chunkedCount: number;
  loadOptions: StandardOption<any>[];
  loadedOptions: StandardOption<any>[];
  infiniteLoading: InfiniteLoading;
  preSelected: StandardOption<any>;
  isClicked: boolean;

  created() {
    this.$logger.debug("OptionListBoxSelector created.");
  }

  mounted(): void {
    this.$logger.debug("OptionListBoxSelector mounted.");
    this.infiniteLoading = this.$refs.infiniteLoading as InfiniteLoading;
  }

  beforeUpdate() {
    this.$logger.debug("OptionListBoxSelector beforeUpdate.");
  }

  updated() {
    this.$logger.debug("OptionListBoxSelector updated.");
  }

  updateLoadOptions(): void {
    const selected = this.selectedOption
      ? this.selectedOption.value
      : null;
    const options = this.filteredOptions.slice();
    for (let i = 0; i < options.length; i++) {
      if (this.areEqual(selected, options[i].value)) {
        this.loadOptions = options.splice(i, 1).concat(options);
        return;
      }
    }
    this.loadOptions = options;
  }

  onInfinite(): void {
    this.$logger.debug("onInifinite");
    this.chunkList();
  }

  private chunkList(): void {
    if (this.chunkedCount === 0) {
      this.updateLoadOptions(); // resetChunkList()で呼び出すとInfiniteLoadingがうまく動作しない
    }
    for (let i = this.chunkedCount; i < (this.chunkedCount + this.loadChunkSize); i++) {
      if (i >= this.loadOptions.length) {
        this.$logger.debug("call complete. i is " + i);
        this.infiniteLoading.stateChanger.complete();
        return;
      }

      this.loadedOptions.push(this.loadOptions[i]);
    }
    this.chunkedCount += this.loadChunkSize;

    this.$logger.debug("call loaded. chunkedCount is " + this.chunkedCount);
    this.infiniteLoading.stateChanger.loaded();
  }

  wheelSelect(e: WheelEvent): void {
    // Firefoxでスクロール量が少なくなるための対策
    // selectタグのイベントで発生したスクロール量が親のdivのスクロールに影響している模様
    // スクロール量は行単位(DeltaMode=1)でdeltaY=2.5を指していたが、ピクセル単位でスクロールしているように見える。
    // selectタグでスクロールイベントを親に通知しないことで対策した。
    // ブラウザチェックをしているのはIEでは動作しなくなるため。
    if (BrowserUtility.getBrowserKind() === BrowserKinds.MozillaFirefox) {
      e.stopPropagation();
    }
  }

  wheel(e: WheelEvent): void {
    // IEでselectタグにフォーカスがある場合スクロールが行われないので手動で制御
    e.preventDefault();
    if (e.currentTarget instanceof HTMLDivElement) {
      e.currentTarget.scrollLeft += e.deltaX;
      e.currentTarget.scrollTop += e.deltaY;
    }
  }

  pointerdown(e: PointerEvent): void {
    // IEとChromeでclickイベントの発生するタイミングとbindされた値が更新されるタイミングが異なるので、
    // clickイベントの前にあらかじめ前回値を記憶しておく
    this.preSelected = this.selectedOption;
  }

  async click(e: PointerEvent): Promise<void> {
    if (!this.isClearable) {
      return;
    }
    await this.$nextTick();
    if (this.preSelected === this.selectedOption) {
      this.selectedOption = null;
      this.isClicked = true;
    }
  }

  scrollIntoView(): void {
    // 選択している位置が画面内の中央になるようスクロールを調整
    const select = (this.$refs.select as HTMLSelectElement);
    const div = (this.$refs.div as HTMLDivElement);
    div.scrollTop = (select.clientHeight * (select.selectedIndex + 1) / select.size) - (div.clientHeight / 2);
  }

  @Watch("filteredOptions")
  onFilteredOptionsUpdated(newValue: any[], oldValue: any[]): void {
    this.resetChunkList();

    if (!this.optionFilter(this.selectedOption)) {
      // 選択状態を解除
      this.selectedOption = null;
    }
  }

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: any, oldValue: any): void {
    if (this.isClicked) {
      this.isClicked = false;
      return;
    }
    this.checkChunkList();
  }

  private checkChunkList(): void {
    const selected = this.selectedOption
      ? this.selectedOption.value
      : null;
    for (const option of this.loadedOptions) {
      if (this.areEqual(selected, option.value)) {
        return;
      }
    }
    this.resetChunkList();
  }

  // ローディング状態をリセット
  resetChunkList(): void {
    this.loadedOptions = [];
    this.chunkedCount = 0;

    if (this.infiniteLoading) {
      this.$logger.debug("call reset.");
      this.infiniteLoading.stateChanger.reset();
    }
  }

  @Emit()
  keyup(e: KeyboardEvent): void {}

  @Emit()
  keydown(e: KeyboardEvent): void {}

  dblclick(e: PointerEvent): void {
    // フィルタで0件になってもselectタグは2行分の領域があるためイベントが発生してしまう
    // また、その際フィルタ以前に選択した状態が維持されるため、そのまま選択されてしまう
    // そのためフィルタが更新された際、範囲外の場合選択状態を解除し、ダブルクリックでは未選択は通知を行わない
    if (this.selectedOption === null) {
      return;
    }
    this.$emit("dblclick", e);
  }
}
